import { useEffect, useState } from "react";

import { Session, SessionTypesEnum } from "../../../../../../types/working-model";
import Icon, { ICONS } from "../../../../../general-ui/icon";
import NavigationDropdown from "../../../../../general-ui/dropdown/navigation-dropdown";

interface SelectDaysProps {
	sessions: Session[];
	onSelect?: (session: Session | null) => void;
	sessionType?: SessionTypesEnum;
	resetCounter?: number;
	label?: string;
}

const SelectDates: React.FC<SelectDaysProps> = ({
	sessions,
	onSelect = () => ({}),
	sessionType,
	resetCounter,
	label
}) => {
	const [selected, setSelected] = useState<Session | null>(null);
	const handleClick = (session: Session | null) => () => {
		if (!session) {
			setSelected(null);
		} else {
			if (session?.timestamp) {
				setSelected(session);
			}
		}
		onSelect(session);
	};

	// if resetCounter increments, then we reset the selected value:
	useEffect(() => {
		setSelected(null);
	}, [resetCounter]);

	const availableDates = () => sessions.reduce((availableSessions: Session[], session: Session) => {
		if (session?.timestamp) {
			let allowBasedOnType = false;
			// if session is on demand, then only show languages from on demand sessions
			if (sessionType === SessionTypesEnum.onDemand && session.session_type === SessionTypesEnum.onDemand) {
				allowBasedOnType = true;
			}
			// if session is broadcast, then only show languages from broadcast sessions
			if (sessionType === SessionTypesEnum.broadcast && session.session_type === SessionTypesEnum.broadcast) {
				allowBasedOnType = true;
			}
			// if no sessionType passed in, then show all languages
			if (!sessionType) {
				allowBasedOnType = true;
			}
			const timestampsSet = new Set(availableSessions);
			if (allowBasedOnType) {
				timestampsSet.add(session);
			}
			return Array.from(timestampsSet);
		}
		return availableSessions;
	}, []);

	const title = selected?.timestamp ? new Date(selected.timestamp).toLocaleDateString(undefined, { month: 'long', day: '2-digit', year: 'numeric' }) : 'ALL DAYS';
	// layouts that include the select days dropdown
	return (
		<div className="agenda-session-filter agenda-session-filter-dates">
			<NavigationDropdown
				title={label ? label : title}
				buttonClassName="agenda-sessions-actions-select"
				edge="center"
				renderCustomIcon={() => (
					<Icon name={ICONS.LITTLE_ARROW_DOWN} color="navdrop-arrow" size={11} />
				)}
			>
				<button className="sharp" onClick={handleClick(null)}>{label ? label : 'ALL DAYS'}</button>
				{availableDates().map((session: Session) => (
					session?.timestamp ? (
						<button key={session.session} className="sharp" onClick={handleClick(session)}>
							{new Date(session.timestamp).toLocaleDateString(undefined, { month: 'long', day: '2-digit', year: 'numeric' })}
						</button>
					) : null
				))}
			</NavigationDropdown>
		</div>
	);
};

export default SelectDates;
